import * as products from '../../products';
import { PRODUCTS, FORM_PREFIX } from './constants';
import { getProductId } from './getProductId';
export const loadSessionStateForExtraProducts = () => {
  const data = sessionStorage.getItem(`${FORM_PREFIX}-${PRODUCTS}`);
  return data ? JSON.parse(data) : null;
};
export const saveSessionStateForExtraProducts = values => {
  sessionStorage.setItem(`${FORM_PREFIX}-${PRODUCTS}`, JSON.stringify(values));
};
export const removeExtraProductsFromPBSession = () => sessionStorage.removeItem(`${FORM_PREFIX}-${PRODUCTS}`);
const getProductsAddedInCart = () => {
  const productsInSessionStorage = loadSessionStateForExtraProducts();
  if (productsInSessionStorage === null) {
    return [];
  }
  return Object.entries(productsInSessionStorage).map(([name, value]) => ({
    name,
    value
  }));
};
export const getFilteredSelectedProductsId = (numberOfTravelers = 1, numberOfSegments = 1) => {
  const selectedExtraProducts = getProductsAddedInCart() || [];
  return selectedExtraProducts.reduce((acc, product) => {
    var _product$value;
    let isSelected = false;
    const rawValue = product === null || product === void 0 || (_product$value = product.value) === null || _product$value === void 0 ? void 0 : _product$value.value;
    switch (product.name) {
      case products.CABIN_UPGRADE.name:
        {
          var _rawValue$selectedUpg;
          const upgrades = rawValue === null || rawValue === void 0 || (_rawValue$selectedUpg = rawValue.selectedUpgrades) === null || _rawValue$selectedUpg === void 0 ? void 0 : _rawValue$selectedUpg.length;
          isSelected = upgrades === numberOfSegments;
          break;
        }
      case products.AIRPORT_TRANSFER.name:
        {
          const val = rawValue === null || rawValue === void 0 ? void 0 : rawValue.toString();
          isSelected = val === 'true' || val === '0' || val === '1';
          break;
        }
      case products.MEAL.name:
        {
          var _product$value2;
          isSelected = (product === null || product === void 0 || (_product$value2 = product.value) === null || _product$value2 === void 0 || (_product$value2 = _product$value2.dropdowns) === null || _product$value2 === void 0 ? void 0 : _product$value2.length) === numberOfTravelers;
          break;
        }
      default:
        {
          var _rawValue$;
          const standardVal = Array.isArray(rawValue) ? (_rawValue$ = rawValue[0]) === null || _rawValue$ === void 0 ? void 0 : _rawValue$.value : rawValue === null || rawValue === void 0 ? void 0 : rawValue.value;
          const normalized = standardVal === null || standardVal === void 0 ? void 0 : standardVal.toString().toUpperCase();
          isSelected = normalized === 'TRUE' || normalized === 'ALL';
        }
    }
    if (isSelected) {
      const id = getProductId(product.name);
      if (id) {
        acc.push(id);
      }
    }
    return acc;
  }, []);
};
//# sourceMappingURL=postBookingProductsUtils.js.map